export enum EmulatorType {
    ZHILAI_DRIVER = 'zhilai_driver',
    QR_READER = 'qr_reader',
    KEYBOARD = 'keyboard'
}
